import { hasImageInput, extractImageFrames, clampTo, resolveVideoSize } from '../../tools';
import type { WavespeedModelConfig } from '../types';

export const openaiConfigs: Record<string, WavespeedModelConfig> = {
    'sora-2-official': {
        // https://wavespeed.ai/zh-CN/models/openai/sora-2/text-to-video
        // https://wavespeed.ai/zh-CN/models/openai/sora-2/image-to-video
        apiPath: (params) => {
            const { frameMode } = params;
            if (frameMode === 'first') {
                return '/openai/sora-2/image-to-video';
            } else {
                return '/openai/sora-2/text-to-video';
            }
        },
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, aspectRatio, quality, modelUi} = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    prompt: prompt,
                    duration: clampTo(duration || 4, [4, 8, 12, 16, 20] as const, 4),
                    // 首帧 URL
                    image: firstImage,
                };
            // 文生视频模式
            } else {
                return {
                    prompt: prompt,
                    size: resolveVideoSize(clampTo(aspectRatio || '16:9', ['16:9', '9:16'] as const, '16:9'), clampTo(quality || '720p', ['720p'] as const, '720p')),
                    duration: clampTo(duration || 4, [4, 8, 12, 16, 20] as const, 4),
                };
            }
        },
    },
    'sora-2-pro-official': {
        // https://wavespeed.ai/zh-CN/models/openai/sora-2/text-to-video-pro
        // https://wavespeed.ai/zh-CN/models/openai/sora-2-pro/image-to-video
        apiPath: (params) => {
            const { frameMode } = params;
            if (frameMode === 'first') {
                return '/openai/sora-2-pro/image-to-video';
            } else {
                return '/openai/sora-2/text-to-video-pro';
            }
        },
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, aspectRatio, quality, modelUi} = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    prompt: prompt,
                    duration: clampTo(duration || 4, [4, 8, 12, 16, 20] as const, 4),
                    resolution: clampTo(quality || '720p', ['720p', '1080p'] as const, '720p'),
                    // 首帧 URL
                    image: firstImage,
                };
            // 文生视频模式
            } else {
                return {
                    prompt: prompt,
                    size: resolveVideoSize(clampTo(aspectRatio || '16:9', ['16:9', '9:16'] as const, '16:9'), clampTo(quality || '720p', ['720p', '1K' ,'1080p'] as const, '720p')),
                    duration: clampTo(duration || 4, [4, 8, 12, 16, 20] as const, 4),
                };
            }
        },
    },
};